import React from "react";

// const buttonColor = "#ED2525";

const GradientHero = ({ children, image, className }) => {
  return (
    <div
      className="overflow-hidden gradient-hero h-full"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="flex items-center">
        <div className="hero-gradient mx-0 lg:mx-32 pt-10 px-14 pb-10">
          {children}
        </div>
      </div>
    </div>
  );
};

export default GradientHero;
